import React from 'react'
import { BaseView, BaseText } from '@/components/base'
import { useTheme } from '@/hooks/useTheme'
import Spinner from './Spinner'

interface RefreshIndicatorProps {
  pullDistance: number
  refreshThreshold: number
  isOverThreshold: boolean
  isRefreshing: boolean
  maxPullDistance: number
  style?: React.CSSProperties
}

export const RefreshIndicator: React.FC<RefreshIndicatorProps> = ({
  pullDistance,
  refreshThreshold,
  isOverThreshold,
  isRefreshing,
  maxPullDistance,
  style,
}) => {
  const progress = Math.min(pullDistance / refreshThreshold, 1)

  const opacity = Math.min(pullDistance / (refreshThreshold * 0.5), 1)

  const theme = useTheme()

  return (
    <BaseView
      style={{
        position: 'absolute',
        top: 0,
        left: '50%',
        transform: `translateX(-50%) translateY(${Math.min(pullDistance - 60, 20)}px)`,
        zIndex: 1000,
        opacity,
        transition: isRefreshing
          ? 'none'
          : 'transform 0.2s ease-out, opacity 0.2s ease-out',
        ...style,
      }}
    >
      <Spinner isSpinning={isRefreshing} />
    </BaseView>
  )
}
